// @vendors
const { createActions } = require('redux-actions');
const isEqual = require('lodash/lang/isEqual');
const get = require('lodash/object/get');
//@helpers
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
// @constants
const PAYROLL_LOAN_RECORD_STATUS = require('../loansConstants/payrollLoanRecordStatus');
const {
    payrollLoanRecordStatus: { NO_RECORD },
    PAYROLL_LOAN_NO_RECORD_MESSAGE
} = require('../loansConstants/index');
const simpleActions = createActions(
    'LOAN_RECORD_STATUS',
    'LOAN_RECORD_STATUS_ERROR',
    'LOAN_RECORD_STATUS_SUCCESS',
    'CONTRACT_EASY_LOAN_TYPEC_UPDATE_LOAN_INFO'
);
const changeCardDeniedVisible = (response) => dispatch => {
    const params = {
        query: {
            cardVisible: false,
            recordId: response.recordId
        }
    };

    APIPost({ dispatch, endpoint: 'payrollLoanSaveInProgress', params });
};

const getLoanRecordStatus = () => (dispatch) => {
    return APIGet({ dispatch, endpoint: 'payrollLoanRecord' }).then(response => {
        if (response.productSubType === '810' || response.productSubType === '802') {
            dispatch(simpleActions.loanRecordStatus());

        }
        dispatch(simpleActions.loanRecordStatusSuccess({ response }));
        dispatch(simpleActions.contractEasyLoanTypecUpdateLoanInfo({ 
            selectedAmount: response.amount,
            selectedTerm: response.term,
        }));
        const cardDeniedVisible = response.cardVisible;
        const isDenied = get(PAYROLL_LOAN_RECORD_STATUS, [response.status, 'checkFlag']);

        if (cardDeniedVisible && isDenied) {
            dispatch(changeCardDeniedVisible(response));
        }
    }).catch(response => {
        if (!!response.error) {
            if (isEqual(response.error.description, PAYROLL_LOAN_NO_RECORD_MESSAGE)) {
                dispatch(simpleActions.loanRecordStatusSuccess({ response: { status: NO_RECORD } }));
            } else {
                dispatch(simpleActions.loanRecordStatusError({ error: response.error }));
            }

        } else {
            throw response;
        }
    });
};

const cancelLoanRecord = (record, finalCallback) => (dispatch, getState) => {
    const params = {
        query: {
            recordId: record || getState().loanRecordStatus.get('recordId')
        }
    };

    dispatch(simpleActions.loanRecordStatus());
    return APIPost({ dispatch, endpoint: 'payrollLoanCancelRecord', params })
        .then(() => {
            dispatch(getLoanRecordStatus());

            if (finalCallback) {
                finalCallback();
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.loanRecordStatusError({ error: response.error }))
            }

            if (finalCallback) {
                finalCallback();
            }
        });
};

module.exports = {
    cancelLoanRecord,
    getLoanRecordStatus,
    simpleActions
};
